import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './CtaBanner.css';

const fadeUp = { hidden: { opacity: 0, y: 30 }, show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: 'easeOut' } } };
const stagger = { hidden: {}, show: { transition: { staggerChildren: 0.15 } } };

export default function CTABanner({
  tag      = 'Ready to claim?',
  title    = 'Your compensation is waiting to be claimed',
  subtitle = 'It takes less than 5 minutes. No upfront cost. No legal knowledge needed.',
  btnText  = 'Check My Compensation',
  btnTo    = '/check-compensation',
}) {
  return (
    <div className="cta-banner">
      <motion.div
        className="cta-banner__inner"
        initial="hidden" whileInView="show"
        viewport={{ once: true, amount: 0.3 }}
        variants={stagger}
      >
        <motion.span className="cta-banner__tag" variants={fadeUp}>{tag}</motion.span>
        <motion.h2 className="cta-banner__title" variants={fadeUp}>{title}</motion.h2>
        <motion.p className="cta-banner__sub" variants={fadeUp}>{subtitle}</motion.p>
        <motion.div variants={fadeUp}>
          <Link to={btnTo} className="cta-banner__btn">
            {btnText} 
          </Link>
        </motion.div>
      </motion.div>
    </div>
  );
}